import { createContext } from 'react'

export const AppbarActionContext = createContext({
  onClick: () => {},
  onMenuShow: () => {},
  getId: () => {}
})
